export function constructLegendWithAggregation(label: string, aggregation?: string): string {
  return `${aggregation && `[${aggregation}] ${label}`}`;
}
